import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "../styles/ticket.module.css";
import styles2 from "../styles/pagination.module.css";
import Tickets from "../components/Tickets";
import UserContext from "../context/user/UserContext";
import { Link, useLocation, useNavigate } from "react-router-dom";
import StateContext from "../context/state/StateContext";
import Filter from "../components/Filter";
import { MultipleLine } from "../components/Analytics/MultipleLine";
import Lottie from "lottie-react";
import { FiRotateCw } from "react-icons/fi";
import io from "socket.io-client";
import animation from "../lottie-icons/no_task.json";
import { toast } from "react-toastify";
import hourglass from "../lottie-icons/hourglass.json";
import InfiniteScroll from "react-infinite-scroll-component";
import Spinner from "../components/Spinner";
import ReactPaginate from 'react-paginate';
import { FaAngleLeft } from "react-icons/fa6";
import { FaAngleRight } from "react-icons/fa6";
import RequestList from "../components/RequestList";
// import SupportFilter from "../components/SupportFilter";


const AgencyRequests = () => {
  const { user, getRequests, verifyUser } = useContext(UserContext);
  const {
    setModal,
    token,
    requests,
    setRequests,
    allTickets,
    setAllTickets,
    allRequests,
    setAllRequests,
    setSuccess,
    setLoading,
    currentPage,
    setCurrentPage,
    totalPages,
    setTotalPages,
    totalRequestPages,
    setTotalRequestPages,
    requestCurrentPage,
    setRequestsCurrentPage,
    totalTickets,
    setTotalTickets,
    isLoading,
    setIsLoading,
    hasMore,
    setHasMore,
    hasMoreSupport,
    setHasMoreSupport,
    fetching,
    setFetching,
    load, setLoad,
    setToDate, setFromDate,
    fromDate, toDate,
    filters, setFilters,
    setFilterItem,
    forcePage, setForcePage,
    setSortBy, setSortOrder,
    setSearchValue, by_search, setBy_search,
    me_search, setMe_search,
  } = useContext(StateContext);

  const [refresh, setRefresh] = useState(false); // State to trigger refresh



  const fetchMoreData = async () => {
    if (hasMore && fetching === false) {
      console.log("Getting for ", currentPage + 1, "Current is", currentPage);
      console.log(currentPage);
      await getRequests(currentPage + 1);
    }
  };

  const navigate = useNavigate();
  const location = useLocation();

  
  const formatDate = (dateString) => {
    const options = { year: '2-digit', month: 'long', day: 'numeric' };
    const date = new Date(dateString);
    return date.toLocaleDateString(undefined, options);
};

  const verifyAndRedirect = async () => {
    setLoading({ open: true, text: "Verifying..." });

    const result = await verifyUser(); // Call the function from context
    if (result?.success) {
      if (user?.verified === false) {
        navigate("/"); // Redirect if the user is not verified
      }
    } else {
      toast.error("Verification failed. Redirecting to login.");
      navigate("/"); // Redirect on failure
    }

    setLoading({ open: false, text: "" });
  };

  const fetchRequests = async () => {
    try {
      setLoad(true)

      const params = new URLSearchParams(location.search);
      const pageFromUrl = parseInt(params.get("page")) || 1;
      const filtersParam = params.get("filters");
      const fromParams = params.get("fromDate");
      const toParams = params.get("toDate");
      const searchParams = params.get("search")
      const sortParams = params.get("sort") || "created_at"
      const orderParams = params.get("order") || "desc"
      const byMeParams = params.get("byMe")
      const toMeParams = params.get("toMe")

      let updatedFilters = {};
      updatedFilters =  filtersParam ? JSON.parse(filtersParam) : {}; // Convert JSON string back to an object
       
      setFilters(updatedFilters);
      let newFilters = updatedFilters && Object.entries(updatedFilters).flatMap(([key, values]) =>
          values.map(value => ({ key, value })) // Store key-value pairs
      );
      if (fromParams && toParams) {
          const deadline = `${formatDate(fromParams)} to ${formatDate(toParams)}`;

          // Remove any previous "deadline" filter and add the new one
          newFilters = newFilters.filter(item => item.key !== "deadline");
          newFilters.push({ key: "deadline", value: deadline });
      }
      setFilterItem(newFilters);
      setToDate(toParams)
      setFromDate(fromParams)
      setSearchValue(searchParams)
      setSortBy(sortParams)
      setSortOrder(orderParams)
      setBy_search(byMeParams)
      setMe_search(toMeParams)
      setCurrentPage(pageFromUrl)
      await getRequests(pageFromUrl, updatedFilters, fromParams, toParams, searchParams, sortParams, orderParams, byMeParams, toMeParams);
    } catch (error) {
      console.log(error);
    } finally {
      setLoad(false)
    }
  }

  useEffect(() => {
    if (token) {
      verifyAndRedirect();
    }
  }, []);

  useEffect(() => {
    fetchRequests()
  }, [location.search])

  const handlePageClick = async (event) => {
      const pageNumber = event.selected + 1; // Get selected page
      const currentParams = new URLSearchParams(window.location.search);
      currentParams.set("page", pageNumber); // Update the page number
      navigate(`?${currentParams.toString()}`);

  };

  return (
    <>
      <div className="container-fluid px-0">
        <div className="heading">
          <h3>Support Requests</h3>
          {user.role !== "agency" ? (
            <div
              className="btn-div"
              onClick={() => setModal({ open: true, component: "AddRequest" })}
            >
              <button className="learn-more" id="add">
                <span className="circle" aria-hidden="true">
                  <span className="icon arrow"></span>
                </span>
                <span className="button-text">Add Request</span>
              </button>
            </div>
          ) : null}
        </div>
        <div className="d-flex align-items-end justify-content-end w-100" onClick={() => setModal({ open: true, component: "AddRequest" })}>
            <button className="learn-more" id="add">
              <span className="circle" aria-hidden="true">
                <span className="icon arrow"></span>
              </span>
              <span className="button-text">Add Tag</span>
            </button>
        </div> 
        {/* <div className="d-flex align-items-end justify-content-between">
          <SupportFilter requests={requests} allRequests={allRequests} />
        </div> */}
        <div className="d-flex align-items-end justify-content-end w-100">
          <button
            onClick={() => {
              setRefresh(true);
              getRequests().then(() => setRefresh(false));
            }}
            className={`refresh ${refresh ? "active" : ""}`} // Add `active` class when loading
          >
            <FiRotateCw />
            {refresh ? "Refreshing..." : "Refresh"}
          </button>
        </div>
        <div
          className="row">
          <div className="col-lg-12 col-12 mt-lg-0 mt-2">
            <div className={styles.tickets}>

            <div className={styles2.pagination}>
              <ReactPaginate
                  breakLabel="..."
                  nextLabel={<FaAngleRight />}
                  onPageChange={handlePageClick}
                  pageRangeDisplayed={1} // Show only the current page
                  marginPagesDisplayed={1} 
                  pageCount={totalRequestPages}
                  forcePage={requestCurrentPage - 1} // Set the active page directly
                  previousLabel={<FaAngleLeft />}
                  renderOnZeroPageCount={null}
                  containerClassName={styles2.paginationContainer}
                  pageClassName={`${styles2.pageItem} ${load ? styles2.disabledPage : ""}`} // Apply disabled style
                  pageLinkClassName={styles2.pageLink}
                  previousClassName={`${styles2.pageItem} ${load ? styles2.disabledPage : ""}`} // Disable previous button
                  previousLinkClassName={styles2.pageLink}
                  nextClassName={`${styles2.pageItem} ${load ? styles2.disabledPage : ""}`} // Disable next button
                  nextLinkClassName={styles2.pageLink}
                  breakClassName={styles2.pageItem}
                  breakLinkClassName={styles2.pageLink}
                  activeClassName={styles2.activePage}
                  disabledClassName={styles2.disabledPage} // Add a disabled class
                  style={{ 
                    display: "flex", 
                    justifyContent: "center", 
                    maxWidth: "320px", 
                    width: "100%", 
                    margin: "0 auto",
                    overflowX: "auto" 
                }}
              />
          </div>        
              {load ? (
                // Loading state
                <div className="d-flex align-items-center justify-content-center w-100">
                  <Lottie
                    className="hourglass"
                    animationData={hourglass}
                    loop={true}
                  />
                </div>
                // <Spinner/>
              ) : requests && requests.length > 0 ? (
                // Render requests when available
                <div>
                  {requests
                    .slice()
                    // .reverse()
                    .map((item, index) => (
                      <RequestList key={index} data={item} index={index} />
                    ))}
                </div>
              ) : (
                // No tickets available
                <div className="lottie-animation">
                  <Lottie animationData={animation} loop={true} />
                  <h3>No Support Requests Here</h3>
                  <p>It seems that you don't have any support requests in this list</p>
                </div>
              )}

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AgencyRequests;
